import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useReduxData from "../../../../Hooks/useReduxData";
import { toast } from "react-toastify";
import { LIST_PRODUCT_BATCHES, LIST_CATEGORY_PRODUCTS, LIST_CATEGORY, REQUEST_INVENTORY, REQUEST_INVENTORY_HISTORY } from "../../../Repository/SettingRepo";
import { RoleTitle } from "../../../../Context/constants";
import { useFormik } from 'formik'

const UseInventory = () => {
    const [loader, setLoader] = useState(false);
    const [TotalCount, setTotalCount] = useState(0);
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });

    const [refreshFlag, setRefreshFlag] = useState(false);

    const [categoryList, setCategoryList] = useState([]);
    const [productList, setProductList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [requestlist, setrequestList] = useState([]);

    const [categoryId, setCategoryId] = useState(null);
    const [productName, setProductName] = useState("");

    const [Filter, setFilter] = useState({
        archive: true,
        search: "",
        disable_button: true,
    });

    const [openModal, setOpenModal] = useState({
        archive: false,
        data: null,
    });

    const { reduxData: userdata } = useReduxData("userDataRDX");

    const headCells = [
        { id: "#", label: "#", numeric: false, disablePadding: true },
        { id: "category", label: "Category", numeric: true },
        { id: "batchNumber", label: "Batch Number", numeric: true },
        { id: "productName", label: "Product Name", numeric: true },
        { id: "manufactureDate", label: "Manufacture Date", numeric: true },
        { id: "expiryDate", label: "Expiry Date", numeric: true },
        { id: "quantity", label: "Quantity", numeric: true },
        // { id: "action", label: "Action", numeric: false, showLeft: true },
    ];

    const navigate = useNavigate();

    const handleOpenModal = (type, data = null) => {
        setOpenModal((prev) => ({ ...prev, data, [type]: true }));
    };



    // API calls

    async function getCategoryList() {
        setLoader(true);
        const payload = {
            activeStatus: Filter.archive,
            providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
            staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        };
        try {
            const response = await LIST_CATEGORY(payload);
            setCategoryList(response?.data || []);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setCategoryList([]);
        } finally {
            setLoader(false);
        }
    }

    async function getProductsList(selectedCategoryId) {
        setLoader(true);
        const payload = {
            activeStatus: Filter.archive,
            providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
            staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            category: selectedCategoryId,
        };
        try {
            const response = await LIST_CATEGORY_PRODUCTS(payload);
            setProductList(response?.data || []);
            setCategoryId(selectedCategoryId);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setProductList([]);
        } finally {
            setLoader(false);
        }
    }

    async function getBatchesList(selectedProductName) {
        setLoader(true);
        const payload = {
            activeStatus: Filter.archive,
            providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
            staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
            category: categoryId,
            productName: selectedProductName,
        };
        try {
            const response = await LIST_PRODUCT_BATCHES(payload);
            setBatchList(response?.data || []);
            setProductName(selectedProductName);
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message);
            setBatchList([]);
        } finally {
            setLoader(false);
        }
    }

    async function getRequestInventoryHistory() {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = controller;
        const { archive, search } = Filter;
        const keyword = search.trim();
        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            activeStatus: archive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
            staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        };
        try {
            let response = await REQUEST_INVENTORY_HISTORY(payload)
            setrequestList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setrequestList([])
            setTotalCount(0)
            setLoader(false)
        }
    }
    const handleClosedModal = (type, refresh = false) => {
        setOpenModal((pre) => ({ ...pre, data: null, [type]: false }));
        if (refresh) {
            setRefreshFlag(prev => !prev); // toggle to trigger useEffect
        }
    };
    const handleRequestInventory = useFormik({
        enableReinitialize: true,
        initialValues: {
            batchNumber: "",
            quantity: "",
            manufactureDate: "",
            expiryDate: "",
            productName: "",
            category: [],
            type: "",
            unit: "",
            strength: "",
            // category: AddCategories?.values?.Categories?.map((cur) => cur?.name),
        },
        // validationSchema: inventoryValidation,
        onSubmit: async (values) => {
            // const { clone, ...restValue } = values
            console.log("Submitting payload", values);
            setLoader(true)
            let payload = {
                ...values,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
                roleTitle: userdata.roleTitle,
                // ...restValue,
                category: values.category?.[0]?.id,
            }
            try {
                let response = await REQUEST_INVENTORY(payload)
                toast.success(response.message)
                setLoader(false)
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })

    const handleChangeFilter = (event) => {
        const { name, value } = event.target;
        setFilter((pre) => ({ ...pre, disable_button: false, [name]: value }));
    };

    const HandleSearchList = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }));
    };

    const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }));
        setFilter({ archive: true, search: "", disable_button: true });
    };

    useEffect(() => {
        getRequestInventoryHistory()
        navigate({ replace: true, state: null })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller, refreshFlag])

    return {
        data: {
            headCells,
            controller,
            Filter,
            TotalCount,
            loader,
            openModal,
            userdata,
            categoryList,
            productList,
            requestlist,
            batchList,
            handleRequestInventory,
        },
        methods: {
            handleChangeFilter,
            HandleSearchList,
            handleOpenModal,
            handleClosedModal,
            setController,
            reset,
            setOpenModal,
            getCategoryList,
            getProductsList,
            getBatchesList,
        },
    };
};

export default UseInventory;
